import React, {useEffect} from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import "./sections.scss"

function TriadBigLeftSec({item,left,left_bottom,left_top,LinkDispatcher}){


    useEffect(()=>{
       console.log("big right " ,item)
    },[])

    return(
        <div className="block-container">
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            {/*left*/}
            {left.image ? <div
                                className={`block-pool ${item.has_shadow?"shadow-sec":""}`}
                               style={{order: 1}}>
                <div className="block-item-vertical">
                    <div className="wrapper"
                         onClick={() => LinkDispatcher(left.link_to, left)}>
                        <img src={left.image} alt=""/>
                        <span className="block-title">{left.title}</span>
                    </div>
                </div>
                <div className="block-item-vertical">

                    <div className="wrapper"
                         onClick={() => LinkDispatcher(left_top.link_to, left_top)}>
                        <img className="max-height" src={left_top.image} alt=""/>
                        <span className="block-title">{left_top.title}</span>
                    </div>
                    <div className="wrapper"
                         onClick={() => LinkDispatcher(left_bottom.link_to, left_bottom)}>
                        <img className="max-height" src={left_bottom.image} alt=""/>
                        <span className="block-title">{left_bottom.title}</span>
                    </div>
                </div>
            </div> : null}

        </div>
            )
}

export default TriadBigLeftSec
